module.exports = __webpack_public_path__ + "img/alex.e912f6e8.svg";